<script>
export default {
  name: "FraudPreventionMenuView"
}
</script>

<template>
  <div>menu</div>
</template>
